import { useState, useRef, useEffect } from "react";
import { useI18n } from "@/context/TranslationContext";
import { Languages, Check, Eye, EyeOff } from "lucide-react";

export const LanguageSwitcher = () => {
  const { locale, setLocale, languages, showOriginal, setShowOriginal } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const active = languages.find((l) => l.code === locale) || languages[0];

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="language-switcher"
        className="flex items-center gap-1.5 rounded-sm px-2.5 py-1.5 text-sm font-medium text-white/70 transition-colors hover:text-white"
      >
        <Languages size={15} />
        <span className="font-semibold">{active.flag}</span>
      </button>
      {open && (
        <div className="absolute right-0 z-50 mt-2 w-52 rounded-md border border-black/10 bg-white p-1.5 shadow-2xl">
          <p className="px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-ek-ink/65">
            Language
          </p>
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                setLocale(l.code);
                setOpen(false);
              }}
              data-testid={`lang-option-${l.code}`}
              className={`flex w-full items-center justify-between rounded-sm px-2.5 py-1.5 text-sm transition-colors ${
                l.code === locale ? "bg-ek-purple/10 text-ek-purple" : "text-ek-ink/75 hover:bg-ek-canvas"
              }`}
            >
              <span className="flex items-center gap-2">
                <span className="w-6 text-xs font-bold text-ek-ink/65">{l.flag}</span>
                {l.label}
              </span>
              {l.code === locale && <Check size={14} />}
            </button>
          ))}
          {locale !== "en" && (
            <>
              <div className="my-1 border-t border-black/5" />
              <button
                onClick={() => setShowOriginal((s) => !s)}
                data-testid="toggle-show-original"
                className="flex w-full items-center gap-2 rounded-sm px-2.5 py-1.5 text-xs text-ek-ink/60 hover:bg-ek-canvas"
              >
                {showOriginal ? <Eye size={13} /> : <EyeOff size={13} />}
                {showOriginal ? "Showing original English" : "Show original English"}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};
